<template>
  <div v-if="isShabbatNow" class="shabbat-banner" role="status">
    <div class="container shabbat-banner-content">
      <span class="shabbat-icon" aria-hidden="true">🕯️</span>
      <span>{{ $t('shabbat.notice') }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useShabbat } from '../composables/useShabbat'

const { isShabbatNow } = useShabbat()
</script>

<style scoped>
.shabbat-banner {
  background: var(--gradient-secondary);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.shabbat-banner-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  padding: var(--space-3) var(--space-6);
  text-align: center;
}

.shabbat-icon {
  font-size: var(--font-size-base);
  line-height: 1;
}

.shabbat-banner span:last-child {
  color: var(--text-light);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  letter-spacing: 0.01em;
}

@media (max-width: 768px) {
  .shabbat-banner-content {
    padding: var(--space-2) var(--space-4);
  }

  .shabbat-banner span:last-child {
    font-size: var(--font-size-xs);
  }
}
</style>
